import React, { useState, Fragment, useEffect } from "react";
import { Stack, Box, Cluster } from "../../atoms/layouts";
import { themeComponent } from "../../../util/themeUtils";
import { fallbackValues } from "./Tabs.theme";
import Tab from "../../atoms/tab";

const HORIZONTAL = "horizontal";

const Tabs = ({
  tabsConfig,
  tabsDisplayMode = HORIZONTAL,
  tabsPadding = "0",
  contentPadding = "0",
  extraStyles = "",
  ...props
}) => {
  const [activeTab, toggleActiveTab] = useState(
    tabsConfig.tabs[0]?.label || null
  );

  useEffect(() => {
    const currentTabExists = tabsConfig.tabs.some(
      tab => tab.label === activeTab
    );

    if (!activeTab || !currentTabExists) {
      toggleActiveTab(tabsConfig.tabs[0]?.label || null);
    }
  }, [tabsConfig, activeTab]);

  const createTabs = (tabConfig, activeTab) => {
    return tabConfig.tabs.map(tab => {
      return (
        <Tab
          activeTab={activeTab}
          key={tab.label}
          label={tab.label}
          setActiveTab={() => toggleActiveTab(tab.label)}
        />
      );
    });
  };

  const showHorizontal = (tabsConfig, activeTab) => {
    return (
      <Cluster justify={"space-around"}>
        {createTabs(tabsConfig, activeTab)}
      </Cluster>
    );
  };

  const showVertical = (tabsConfig, activeTab) => {
    return <Stack>{createTabs(tabsConfig, activeTab)}</Stack>;
  };

  return (
    <Box className="tabs" padding="0" extraStyles={extraStyles} {...props}>
      <Box className="tab-list" padding={tabsPadding}>
        {tabsDisplayMode == HORIZONTAL
          ? showHorizontal(tabsConfig, activeTab)
          : showVertical(tabsConfig, activeTab)}
      </Box>
      <Box className="tab-content" padding={contentPadding}>
        <Box padding="0">
          {tabsConfig.tabs.map((tab, idx) => {
            if (tab.label !== activeTab) return undefined;
            return <Fragment key={idx}>{tab.content}</Fragment>;
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default themeComponent(Tabs, "NavigationTab", fallbackValues);
